var _defs, _circle, _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.74 8.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0071bc;\n      }\n\n      .st1 {\n        fill: #ce2929;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4.34,
    cy: 4.42,
    r: 3.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.37,0C1.96,0,0,1.96,0,4.37s1.96,4.37,4.37,4.37,4.37-1.96,4.37-4.37S6.78,0,4.37,0ZM4.37,8.08c-2.04,0-3.71-1.66-3.71-3.71S2.32.66,4.37.66s3.71,1.66,3.71,3.71-1.66,3.71-3.71,3.71Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 4.03,
    y: 0.36,
    width: 0.66,
    height: 8.02,
    transform: "translate(-1.81 4.36) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 0.52,
    y: 3.97,
    width: 7.82,
    height: 0.66,
    transform: "translate(-1.74 4.39) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopSign);
export default __webpack_public_path__ + "static/media/stop-sign.27babf954fe5588df1e8481a4b52083e.svg";
export { ForwardRef as ReactComponent };